"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isDatetime = void 0;
var DateTimeInputTypes;
(function (DateTimeInputTypes) {
  DateTimeInputTypes[DateTimeInputTypes["datetime-local"] = 0] = "datetime-local";
  DateTimeInputTypes[DateTimeInputTypes["date"] = 1] = "date";
  DateTimeInputTypes[DateTimeInputTypes["month"] = 2] = "month";
  DateTimeInputTypes[DateTimeInputTypes["time"] = 3] = "time";
  DateTimeInputTypes[DateTimeInputTypes["week"] = 4] = "week";
})(DateTimeInputTypes || (DateTimeInputTypes = {}));
var isDatetime = function isDatetime(string) {
  return typeof string === 'string' && string in DateTimeInputTypes;
};
exports.isDatetime = isDatetime;